import React from "react";
import { twMerge } from "tailwind-merge";

interface MenuItemProps {
  children?: React.ReactNode;
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
}

export const MenuItem: React.FC<MenuItemProps> = ({ children, disabled = false, className, onClick }) => (
  <button
    type="button"
    className={twMerge(
      "flex items-center w-full px-4 py-2 text-sm text-text-primary hover:bg-limestone-50 transition-colors disabled:opacity-50 disabled:cursor-default",
      className,
    )}
    disabled={disabled}
    onClick={onClick}
  >
    {children}
  </button>
);
